import React from "react"
import { InvitationByTokenQuery } from "~/__generated__/graphql"
import { UserAvatar } from "~/users/user-avatar"
import Text from "~/ui/typography"

type Invitation = NonNullable<InvitationByTokenQuery["invitationByToken"]>

interface InvitationCardProps {
  invitation: Invitation
}

export const InvitationCard: React.FC<InvitationCardProps> = ({ invitation }) => {
  const inviterName = invitation.user.fullName || invitation.user.handle || "Unknown User"
  const inviterHandle = invitation.user.handle ? `@${invitation.user.handle}` : ""

  return (
    <div className="mx-auto mb-[100px] overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
      <div className="space-y-2 p-6">
        <Text as="h2" variant="heading4" className="text-gray-900">
          You've been invited!
        </Text>
        <Text className="text-sm text-gray-600">
          You've been invited to join {inviterName}'s Contacts.
          <br />
          Please connect your wallet to get started.
        </Text>
      </div>

      <div className="flex items-center space-x-3 bg-invitation-bg p-4">
        <UserAvatar user={invitation.user} />
        <div className="flex flex-col">
          <Text className="font-medium text-gray-900">{inviterName}</Text>
          {inviterHandle && <Text className="text-sm text-gray-500">{inviterHandle}</Text>}
        </div>
      </div>
    </div>
  )
}
